module.exports = __webpack_public_path__ + "images/icon-report@x3.png";